module.exports = __webpack_public_path__ + "img/medium-remnants-ground-patch.2acacd44.png";